import React, { useEffect, useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import { XCircle } from 'lucide-react';
import Cookies from "js-cookie";
import { SessionContext } from "../context/sessionContext";

const PaymentCancelled = () => {
  const navigate = useNavigate();
  const { setSession } = useContext(SessionContext);

  useEffect(() => {
    const restoreSession = () => {
      let token = Cookies.get("token");
      
      if (!token) {
        const storedSession = localStorage.getItem("userSession");
        
        if (storedSession) {
          try {
            const session = JSON.parse(storedSession);
            token = session.token;
          
            if (token) {
              Cookies.set("token", token, { expires: 2 });
              setSession({ token, user: session.user });
            }
          } catch (e) {
            console.error("Failed to parse stored session:", e);
          }
        }
      }
      localStorage.removeItem("userSession");
    };

    restoreSession();
  }, [setSession]);

  const handleBackToPricing = () => {
    navigate('/pricing');
  };

  return (
    <div className="payment-success-overlay">
      <div className="payment-success-modal">
        <div className="create-survey-logo">
          <a href="/">
            <img
              src="/json-media/img/logo.svg"
              alt="GI"
              width={50}
              style={{ padding: 5 }}
            />
          </a>
        </div>

        <div className="payment-success-content">
          <div className="payment-success-icon" style={{ color: '#ef4444' }}>
            <XCircle size={64} />
          </div>

          <h1 className="payment-success-title">Payment Cancelled</h1>
          
          <p className="payment-success-message">
            Your payment was cancelled. No charges have been made to your account.
            You can go back to select a plan whenever you're ready.
          </p>

          <button 
            className="payment-success-button"
            onClick={handleBackToPricing}
          >
            Back to Pricing
          </button>
        </div>

        <div className="payment-success-gradient"></div>
      </div>
    </div>
  );
};

export default PaymentCancelled;